
import React from 'react';

import ListInfo from './ListInfo';

const ListInfoLoading = () => {
    return (
        <ListInfo info="Nahrávám data..." />
    );
}

export default ListInfoLoading;
